// extracted by mini-css-extract-plugin
module.exports = {"formInfo":"style_formInfo__3-HjB","name":"style_name__3mmLG","email":"style_email__1x51I"};